module.exports = __webpack_public_path__ + "img/Loading_xh_11.7e9b6e80.png";